export const listBankAccounts = `
   query listBankAccounts($filter: BankAccountsFilterInput, $limit: Int, $nextToken: String) {
       listBankAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              customerId
              country
              currency
              accountHolderName
              accountHolderType
              bankName
              routingNumber
           }
           nextToken
       }
   }
`;

export const getBankAccount = `
   query getBankAccount($customerId: ID!, $id:ID!) {
       getBankAccount(customerId:$customerId, id:$id) {
          id
          customerId
          country
          currency
          accountHolderName
          accountHolderType
          bankName
          routingNumber
       } 
}`;
